// @flow

import React from 'react';
import styled from 'styled-components';
import TagPill from './tag-pill';
import RowTagEditor from './row-tag-editor';
import type { TagTypeMeta } from './tag-types';
import type { TagPermissionsT } from './use-tag-permissions';

type TagT = {
  id: string,
  tagType: string,
  tagValue: string,
};

type Props = {
  location: Object,
  permissions: TagPermissionsT,
  tagTypes: TagTypeMeta[],
  allTags: $ReadOnlyArray<Object>,
  onAddTag: (locationId: string, tag: Object) => mixed,
  onRemoveTag: (locationId: string, tagId: string) => mixed,
};

const Cell = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  padding: 4px 0;
`;

const Empty = styled.span`
  font-size: 11px;
  color: #a7b6c2;
  font-style: italic;
  margin-right: 4px;
`;

const RowTagsCell = ({
  location,
  permissions,
  tagTypes,
  allTags,
  onAddTag,
  onRemoveTag,
}: Props) => {
  const tagIds = location.tags || [];
  const tagsById: { [string]: TagT } = {};
  allTags.forEach((t) => {
    tagsById[t.id] = t;
  });
  const resolved: TagT[] = tagIds
    .map((id) => tagsById[id])
    .filter(Boolean);

  return (
    <Cell onClick={(e) => e.stopPropagation()}>
      {resolved.length === 0 && <Empty>No tags</Empty>}
      {resolved.map((t) => (
        <TagPill
          key={t.id}
          tag={t}
          tagTypes={tagTypes}
          size="sm"
          onRemove={
            permissions.canRemoveTagFromLocation
              ? () => onRemoveTag(location.id, t.id)
              : undefined
          }
        />
      ))}
      {permissions.canAssignTagToLocation && (
        <RowTagEditor
          location={location}
          allTags={allTags}
          tagTypes={tagTypes}
          size="sm"
          onAdd={(tag) => onAddTag(location.id, tag)}
        />
      )}
    </Cell>
  );
};

export default RowTagsCell;
